var React = require('react');

function M2BookmarkCircleComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm5-5V7H7v11l5-2.823L17 18z","fill":"currentColor"}));
}

M2BookmarkCircleComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = M2BookmarkCircleComponent;

M2BookmarkCircleComponent.default = M2BookmarkCircleComponent;
